<template>
	<b-container>
		<clock-form :clock="clock" :dirty.sync="dirty" @delete="deleteClock" @update="updateClock" :editable="editable" />

		<confirm ref="confirm"></confirm>
	</b-container>
</template>

<script>
import ClockService from '@/api-services/clock.service';
import ClockForm from '@/components/clock/clock-form';
import Confirm from '@/components/partials/confirm';

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'leaflet-control-geocoder';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';

export default {
	name: 'ClockUpdate',

	components: {
		ClockForm,
		Confirm
	},

	data() {
		return {
			clock: {
				Address: {},
				Customer: {},
				ClockType: {},
				Equipment: [],
				Escapements: [],
				Dials: [],
				Contacts: [],
				Assets: [],
				ServiceContracts: []
			},

			editing: {
				id: null,
				index: null
			},

			editable: {
				name: false,
				address: false,
				notes: false,
				details: false
			},

			map: null,
			tileLayer: null,
			dirty: false,
			marker: null
		};
	},

	// components are in the DOM
	mounted() {
		this.fetchClock();
	},

	// check our dirty variable and warn them
	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.$refs.confirm.open('Attention', 'Do you really want to leave? you have unsaved changes!').then((confirm) => {
				if (confirm) {
					next();
				} else {
					next(false);
				}
			});
		} else {
			next();
		}
	},

	methods: {
		fetchClock() {
			ClockService.get(this.$router.currentRoute.params.id)
				.then((response) => {
					this.clock = response.data;

					if (this.clock.Address.Latitude == null && this.clock.Address.Longitude == null) {
						// so we can set the map properly
						this.clock.Address.Empty = true;
					}

					this.initMap();
					this.initLayers();
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		hasLtnLng() {
			return !this.clock.Address.Empty;
		},

		initMap() {
			if (this.hasLtnLng()) {
				this.map = L.map('map').setView([this.clock.Address.Latitude, this.clock.Address.Longitude], 10);
			} else {
				this.map = L.map('map').setView([54.4, -2.8], 7);
			}

			this.tileLayer = L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
				maxZoom: 18,
				attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
			});

			this.tileLayer.addTo(this.map);
			// add search
			L.Control.geocoder().addTo(this.map);

			// to avoid scope conlict with this
			var vm = this;

			this.map.on('click', function (e) {
				if (vm.editable.address) {
					if (confirm('Set Map location?')) {
						vm.clock.Address.Latitude = e.latlng.lat.toFixed(6);
						vm.clock.Address.Longitude = e.latlng.lng.toFixed(6);

						vm.dirty = true;
						vm.clock.Address.Empty = false;
						if (vm.marker) vm.marker.remove();

						vm.initLayers();
					}
				}
			});
		},

		initLayers() {
			if (this.hasLtnLng()) {
				this.marker = L.marker([this.clock.Address.Latitude, this.clock.Address.Longitude]);

				this.marker.addTo(this.map);
			}
		},

		updateClock(section) {
			let okToSave = true;

			// don't save if there's it's not dirty -- always save if there's no specific section given
			if (section && !this.dirty) okToSave = false;

			if (okToSave) {
				ClockService.update(this.$router.currentRoute.params.id, this.clock)
					.then(() => {
						this.dirty = false;

						// only close editable sections on success
						if (section) this.editable[section] = false;
					})
					.catch((error) => {
						this.handleError(error);
					});
			} else {
				if (section) this.editable[section] = false;
			}
		},

		deleteClock() {
			this.$refs.confirm.open('Delete', 'Are you sure you want to delete this clock?').then((confirm) => {
				if (confirm) {
					ClockService.delete(this.clock.Id)
						.then(() => {
							this.$refs.confirm.open('Success', 'Successfully deleted clock', true).then((confirm) => {
								this.$router.push({ name: 'clocks' });
							});
						})
						.catch((error) => {
							this.handleError(error);
						});
				}
			});
		},

		handleError(err) {
			let modal_options = {
				text: 'light',
				background: 'danger'
			};

			let message;

			if (err.response.data != '') {
				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;
			} else {
				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/clock/clock-update.vue